import axios from 'axios'
import env from 'src/../env.js'

const config = require('src/../config/index')
const configLabels = require('src/../config/label')

if (window.localStorage.getItem(env.site + '_baseURL') === null) {
  let location = window.location
  // let baseURL = (process.env.NODE_ENV !== 'development') ? location.protocol + '//' + location.host + '/' : config.build.defaultBaseURL
  let baseURL = (process.env.NODE_ENV !== 'development') ? location.origin + '/' : config.build.defaultBaseURL
  window.localStorage.setItem(env.site + '_baseURL', baseURL)
}
let location = window.location
let baseURL = (process.env.NODE_ENV !== 'development') ? location.origin + '/' : config.build.defaultBaseURL
export let instance = function () {
  return axios.create({
    baseURL: baseURL,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=utf-8',
      'currentUser': configLabels.getCurrentUserHeader()
    },
    validateStatus: function (status) {
      return status >= 200 && status < 300
    }
  })
}

export const endpoint = config.build.apiVersion
export const isMock = (process.env.NODE_ENV !== 'production' && config.build.mocker)
export const isMockLogin = (process.env.NODE_ENV !== 'production' && config.build.mockerLogin)

export const generator = (mocker) => {
  return Promise.resolve({
    request: {
      response: JSON.stringify(mocker)
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js